import { gql } from "@apollo/client";

export const GET_REFERRALS_BY_SERVICE_NAME = gql`
  query SearchReferralByServiceName($serviceName: String!, $orgId: String!) {
    searchReferralByServiceName(serviceName: $serviceName, orgId: $orgId) {
      id
      from
      user {
        id
        firstName
        lastName
        email
      }
      userId
      eligibilityStatus
      serviceId
      serviceName
      orgId
      status
      isSelfReferral
    }
  }
`;
